/**
 * Mensajes públicos alineados a la etapa de lanzamiento:
 * búsqueda y contacto primero; dashboard como solicitud con activación progresiva.
 */

export const LAUNCH = {
  heroTitle: 'Encuentra talleres, repuestos y servicios automotrices cerca de ti',
  heroLead:
    'Busca empresas por servicio, marca o ubicación, revisa sus perfiles públicos y contáctalas directamente desde Kawescar.',
  heroDashboardNote:
    'Si quieres acceder a tu dashboard como cliente o empresa, ya puedes enviar tu solicitud. Los accesos se habilitarán de forma progresiva y te avisaremos por correo.',
  promo500Short: 'Primeros 500 clientes: 1 mes de membresía premium gratis.',
  ctaBuscarCercanas: 'Buscar empresas ',
  ctaSolicitarCliente: 'Solicitar acceso cliente',
  ctaSolicitarEmpresa: 'Solicitar acceso empresa',
  ctaLanzamiento: 'Quiero ser parte del lanzamiento',
  ctaMesPremium: 'Quiero mi mes premium',
  valorTitulo: 'Todo en un solo lugar para encontrar soluciones automotrices',
  valorTexto:
    'Descubre empresas del rubro automotriz según cercanía, explora sus servicios, revisa sus perfiles y utiliza sus canales de contacto de forma rápida y simple.',
  /** Bloque valor (Home): cuando el usuario no ha activado geolocalización */
  valorTextoSinUbicacion:
    'Explora el directorio de empresas del rubro automotriz: servicios, perfiles públicos y canales de contacto. Activa tu ubicación para ordenar por cercanía y ver distancias aproximadas.',
  bannerLineas: [
    'Las solicitudes ya están abiertas.',
    'Activación progresiva y aviso por correo.',
    'Primeros 500 clientes: 1 mes premium gratis.',
  ],
  mensajeApoyo:
    'KawésCar ya te permite buscar empresas, descubrir opciones cercanas, revisar perfiles públicos y contactar servicios automotrices. Si quieres acceder a nuevas funcionalidades, puedes enviar tu solicitud y te avisaremos por correo cuando esté disponible.',
  beneficio500Completo:
    'Los primeros 500 clientes que envíen una solicitud válida y sean activados recibirán 1 mes de membresía premium gratis.',
  formClienteTitulo: 'Solicitud de acceso cliente',
  formClienteSubtitulo:
    'Completa tus datos para quedar dentro del proceso de activación de Kawescar. Te avisaremos por correo cuando tu acceso esté listo.',
  formClienteApoyo:
    'Si tu solicitud está dentro de las primeras 500 válidas y eres activado, recibirás 1 mes de membresía premium gratis.',
  formEmpresaTitulo: 'Solicitud de empresa',
  formEmpresaSubtitulo:
    'Completa tu solicitud y un agente se pondrá en contacto contigo para revisar tu caso, validar la información y orientarte sobre la solución más adecuada para tu empresa.',
  exitoTitulo: 'Tu solicitud fue recibida con éxito',
  exitoClienteCuerpo:
    'Tu solicitud ya fue registrada en Kawescar. Los accesos se habilitarán de forma progresiva y te avisaremos por correo electrónico cuando tu dashboard esté listo.',
  exitoClienteExtra:
    'Si tu solicitud está dentro de las primeras 500 válidas y eres activado, recibirás 1 mes de membresía premium gratis.',
  exitoEmpresaCuerpo:
    'Solicitud enviada correctamente. Un agente se pondrá en contacto contigo para revisar tu caso, validar la información y explicarte los siguientes pasos.',
  btnEntendido: 'Entendido',
  btnCerrar: 'Cerrar',
  btnContinuar: 'Continuar',
  ctaMiCuenta: 'Mi cuenta',
  ctaVerTodasEmpresas: 'Explorar todas las empresas',
  /** Bloque buscador superior en Home (antes del hero Kawescar) */
  buscadorHomeTitulo: 'Buscar empresas del rubro automotriz',
  buscadorHomeSubtitulo:
    'Busca por marca, servicio, revisa perfiles públicos y contacta directamente cada empresa.',
  /** Usuario ya autenticado en Home */
  bannerLogueadoTitulo: 'Sigue explorando el directorio o entra a tu cuenta',
  bannerLogueadoTexto:
    'KawésCar está pensado para buscar empresas cercanas, revisar perfiles y contactar servicios. Desde tu cuenta usarás las funciones que ya tengamos habilitadas para ti.',
  /** Sección roles en Home */
  bloqueRolesTitulo: 'Encuentra servicios hoy · solicita acceso cuando quieras más funciones',
  bloqueClienteTituloCard: 'Solicita tu acceso como cliente',
  bloqueClienteSubtituloCard: 'Solicitud de acceso cliente',
  bloqueClienteCuerpo:
    'Envía tu solicitud para ser parte de Kawescar. Los accesos se habilitarán de forma progresiva y te avisaremos por correo electrónico cuando tu dashboard esté listo.',
  bloqueEmpresaTituloCard: 'Solicita tu acceso como empresa',
  bloqueEmpresaSubtituloCard: 'Solicitud de acceso empresa',
  bloqueEmpresaCuerpo:
    'Las empresas ya pueden enviar su solicitud para acceder a Kawescar. Las activaciones se realizarán de forma progresiva y serán notificadas por correo electrónico.',
  tipPostRoles:
    'Puedes usar el directorio público ahora mismo. Las solicitudes de acceso se revisan por orden; te avisaremos por correo cuando corresponda.',
  beneficioLanzamientoLabel: 'Beneficio de lanzamiento:',
  /** Paso inicial formulario cliente (modal lógico) */
  pasoCeroClienteIntro:
    'KawésCar ya te permite buscar empresas, revisar perfiles y contactarlas sin completar este formulario. Activa la opción inferior solo si quieres enviar tu solicitud de acceso como cliente.',
  opcionTarjetaSolicitudCliente: 'Solicitar acceso cliente',
  opcionTarjetaSolicitudClienteDetalle:
    'Activa esta opción para completar el formulario. La habilitación es progresiva; te notificaremos por correo cuando tu acceso esté listo.',
  resumenSolicitudAccesoCliente: 'Solicitud de acceso cliente',
  loginEligeExperienciaTitulo: 'Accede si ya tienes cuenta habilitada',
  loginTarjetaClienteTitulo: 'Cuenta cliente',
  loginTarjetaClienteTexto:
    'Para quienes ya tienen acceso: vehículos, recordatorios y herramientas según tu plan. ¿Aún no? Envía una solicitud de acceso cliente.',
  loginTarjetaEmpresaTitulo: 'Cuenta empresa',
  loginTarjetaEmpresaTexto:
    'Para empresas ya activadas: visibilidad y gestión en la comunidad. ¿Nueva empresa? Envía solicitud de acceso empresa.',
  redirigiendoCuenta: 'Entrando a tu cuenta',
  solicitudEmpresaEnRevisionTitulo: 'Solicitud registrada',
  solicitudEmpresaEnRevisionTexto:
    'Tu solicitud está en el proceso de activación progresiva. Te avisaremos por correo electrónico cuando haya novedades.',
  /** Modal activación promo 1 mes (dashboard cliente) */
  modalPremiumPromoContexto:
    'Como parte del beneficio de lanzamiento para primeros clientes activados, ',
};
